//  Валидация ИНН
export const validateInn = (rule, value) => {
  const error = { code: 0, message: "" };

  if (typeof value === "number") {
    value = value.toString();
  } else if (typeof value !== "string") {
    value = "";
  }

  if (!value.length) {
    return Promise.resolve();
  } else if (/[^0-9]/.test(value)) {
    error.code = 2;
    error.message = "ИНН может состоять только из цифр";
  } else if ([10, 12].indexOf(value.length) === -1) {
    error.code = 3;
    error.message = "ИНН может состоять только из 10 или 12 цифр";
  } else {
    const checkDigit = (inn, coefficients) => {
      let n = 0;
      for (let i in coefficients) {
        n += coefficients[i] * inn[i];
      }
      return parseInt((n % 11) % 10);
    };

    let result = false;
    switch (value.length) {
      case 10:
        const n10 = checkDigit(value, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
        if (n10 === parseInt(value[9])) {
          result = true;
        }
        break;
      case 12:
        const n11 = checkDigit(value, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
        const n12 = checkDigit(value, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
        if (n11 === parseInt(value[10]) && n12 === parseInt(value[11])) {
          result = true;
        }
        break;
      default:
        break;
    }

    if (!result) {
      error.code = 4;
      error.message = "Неправильное контрольное число";
    }
  }

  if (error.code !== 0) {
    return Promise.reject(new Error(error.message));
  }

  return Promise.resolve();
};

// Валидация КПП
export const validateKpp = (rule, value) => {
  const error = { code: 0, message: "" };

  if (typeof value === "number") {
    value = value.toString();
  } else if (typeof value !== "string") {
    value = "";
  }

  if (!value.length) {
    error.code = 1;
    error.message = "КПП пуст";
  } else if (value.length !== 9) {
    error.code = 2;
    error.message =
      "КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)";
  } else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(value)) {
    error.code = 3;
    error.message = "Неправильный формат КПП";
  } else {
    return Promise.resolve();
  }

  return Promise.reject(new Error(error.message));
};
